export default __webpack_public_path__ + "static/media/report.3f4884f9.jpg";